import type {
  HanziCharacterWritingSkill,
  HanziWordSkill,
  Skill,
} from "@/data/model";
import { SkillKind } from "@/data/model";
import {
  hanziCharacterFromWritingSkill,
  skillKindFromSkill,
} from "@/data/skills";
import { Text } from "@/client/ui/Text";
import { HanziLink } from "./HanziLink";
import { HanziWordToGlossSkillAnswerText } from "./HanziWordToGlossSkillAnswerText";
import { HanziWordToPinyinSkillAnswerText } from "./HanziWordToPinyinSkillAnswerText";

export const SkillAnswerText = ({ skill }: { skill: Skill }) => {
  switch (skillKindFromSkill(skill)) {
    case SkillKind.HanziCharacterToWriting: {
      const hanzi = hanziCharacterFromWritingSkill(
        skill as HanziCharacterWritingSkill,
      );
      return (
        <Text className="pyly-body-2xl">
          <HanziLink hanzi={hanzi}>{hanzi}</HanziLink>
        </Text>
      );
    }
    case SkillKind.Deprecated_EnglishToRadical:
    case SkillKind.Deprecated_PinyinToRadical:
    case SkillKind.Deprecated_RadicalToEnglish:
    case SkillKind.Deprecated_RadicalToPinyin:
    case SkillKind.Deprecated:
    case SkillKind.GlossToHanziWord:
    case SkillKind.ImageToHanziWord:
    case SkillKind.PinyinFinalAssociation:
    case SkillKind.PinyinInitialAssociation:
    case SkillKind.PinyinToHanziWord: {
      throw new Error(
        `ShowSkillAnswer not implemented for ${skillKindFromSkill(skill)}`,
      );
    }
    case SkillKind.HanziWordToGlossTyped:
    case SkillKind.HanziWordToGloss: {
      // oxlint-disable-next-line typescript/no-unnecessary-type-assertion
      skill = skill as HanziWordSkill;
      return <HanziWordToGlossSkillAnswerText skill={skill} />;
    }
    case SkillKind.HanziWordToPinyinTyped:
    case SkillKind.HanziWordToPinyinFinal:
    case SkillKind.HanziWordToPinyinInitial:
    case SkillKind.HanziWordToPinyinTone: {
      // oxlint-disable-next-line typescript/no-unnecessary-type-assertion
      skill = skill as HanziWordSkill;
      return <HanziWordToPinyinSkillAnswerText skill={skill} />;
    }
  }
};
